/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable react/jsx-filename-extension */
import React  from 'react'
import { Route, Redirect } from 'react-router-dom'
import { readCookie } from '../utils/cookies'
import { Routes } from './routes'

const GuardedRoute = ({ component: Component, ...rest }) => {
  return(
    <Route
      {...rest}
      render={(props) =>
        readCookie('token') ? (
          <Component {...props} />
        ) : (
          <Redirect to={Routes.LOGIN} />
        )
      }
    />
  )
}

export default GuardedRoute
